export default "__VITE_ASSET__k6vZ4jMs__"